import React, { useEffect } from 'react';
import { BrowserRouter as Router, Link, Route, Routes, useLocation } from 'react-router-dom';
import BlogList from './pages/blogList/blogList';
import Blog from './pages/blog/blog';
import Home from './pages/home/home';
import ContactPage from './pages/contact/contact';
import Header from './components/header/header';
import Footer from './components/footer/footer';
import PageMeta from './components/pageMeta/PageMeta';
import './App.css';

const NavigationEffects = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      const prefersReducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
      const timer = window.setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({
          behavior: prefersReducedMotion ? 'auto' : 'smooth',
          block: 'start',
        });
      }, 40);
      return () => window.clearTimeout(timer);
    }
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, [location.pathname, location.hash]);

  return null;
};

const NotFound = () => (
  <>
    <PageMeta
      title="Page not found | TryOuts"
      description="The page you requested could not be found."
      path="/404"
    />
    <Header />
    <main id="main-content" className="route-shell section section--night">
      <div className="container">
        <p className="eyebrow">404 / off the map</p>
        <h1 className="section-title">This workflow has no next step.</h1>
        <p className="section-intro">The page may have moved. Return home to keep exploring TryOuts.</p>
        <Link className="button button--primary" to="/">Return home</Link>
      </div>
    </main>
    <Footer />
  </>
);

function App() {
  return (
    <div className="main-page">
      <Router>
        <a className="skip-link" href="#main-content">Skip to content</a>
        <NavigationEffects />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/blog" element={<BlogList />} />
          <Route path="/blog/:name" element={<Blog />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
